import { createSlice } from '@reduxjs/toolkit'

export interface IContactViewState {
    uploadAvatarModal: boolean
    copyInvitationModal: boolean
}

const initialState: IContactViewState = {
    uploadAvatarModal: false,
    copyInvitationModal: false
}

const contactViewSlice = createSlice({
    name: 'ui/contact',
    initialState,
    reducers: {
        setUploadAvatarModal(state, action) {
            state.uploadAvatarModal = action.payload
        },
        setCopyInvitationModal(state, action) {
            state.copyInvitationModal = action.payload
        }
    }
})

export const contactActions = contactViewSlice.actions
export default contactViewSlice.reducer
